var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-add-circle-outline",
    "data-name": "Icon ionic-ios-add-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M21.4,15.515H17.285V11.4a.885.885,0,1,0-1.769,0v4.119H11.4a.847.847,0,0,0-.885.885.856.856,0,0,0,.885.885h4.119V21.4a.857.857,0,0,0,.885.885.88.88,0,0,0,.885-.885V17.285H21.4a.885.885,0,1,0,0-1.769Z",
    transform: "translate(-1.525 -1.525)",
    fill: "#12819c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M14.875,4.923A9.948,9.948,0,1,1,7.837,7.837a9.886,9.886,0,0,1,7.038-2.914m0-1.548a11.5,11.5,0,1,0,11.5,11.5,11.5,11.5,0,0,0-11.5-11.5Z",
    fill: "#12819c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadProject);
export default __webpack_public_path__ + "static/media/upload-project.64e3342266247b0f838a658fcad2b7e6.svg";
export { ForwardRef as ReactComponent };